<ng-container *ngIf="action.type === 'application'; else api">
  <a [routerLink]="ctaLink(action)" class="fl-task-button">{{action.cta}}</a>
</ng-container>
<ng-template #api>
  <button (click)="postApiAction(action, $event)" class="fl-task-button">{{action.cta}}</button>
</ng-template>
